import React, { useEffect, useState, useRef } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FileDownload from '../../../../icons/money-coins.svg';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import FileTable from '../SubComponents/FileTable';
import NextStepModal from '../../../Common/ScheduleAppointment/NextStepModal';
import { format } from 'date-fns-tz';
import { httpRequest } from '../../../../httpRequest';
import '../../../Common/ScheduleAppointment/ScheduleAppointment.scss';
import TitleComponent from '../../../Common/TitleComponent';
import BackNextButton from '../../../Common/BackNextButton';

const useStyles = makeStyles((theme) => ({
    buttonReplace: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
    disabledButtonSelect: {
        color: 'rgba(0, 0, 0, 0.26)',
        boxShadow: 'none',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        cursor: 'pointer',
        padding: '6px 16px',
        fontSize: '0.875rem',
        boxSizing: 'border-box',
        fontWeight: '500',
        lineHeight: '1.75',
        borderRadius: '4px',
        textAlign: 'center'
    },
    buttonSelect: {
        color: theme.palette.primary.main,
        border: ' 1px solid rgba(48, 67, 147, 0.5)',
        boxShadow: '0px 2px 4px 0px lightgrey',
        backgroundColor: 'rgba(255, 255, 255, 1)',
        textTransform: 'none',
        cursor: 'pointer',
        padding: '6px 16px',
        fontSize: '0.875rem',
        boxSizing: 'border-box',
        fontWeight: '500',
        lineHeight: '1.75',
        borderRadius: '4px',
        textAlign: 'center'
    },
    blueText: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
        fontSize: '600'
    }
}));
export default function ReplaceFile(props) {
    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });
    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;

    const defaultFileState = {
        fileList: [],
        key: [],
        filesLoading: false,
        selectedFileDetails: null,
        updateFileTable: false,
        itemsPerPage: 10,
        nextPageMax: 5,
        pageNumber: 1,
        totalPages: 0,
        pageAddVisible: true,
        pageSubtractVisible: false,
        fileDetailsLoading: false,
        showCaseDetailsView: false,
        selectedCaseDetails: null,
    };
    const [fileState, updateFileState] = useState(defaultFileState);
    const [fileData, setFileData] = useState([]);
    const [postingApp, setPosting] = useState(false)
    const inputFile = useRef(null);
    const [modalShow, setModalShow] = useState(false);

    const [error, displayError] = useState("");
    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    useEffect(() => {
        handleValueChange('file', fileState)
    }, [fileState])

    useEffect(() => {
        // manually register fields for validation that don't play nice with react-hook-form register
        register({ name: 'file' });
        setValue('file', props.formState.file);

    }, [register]);

    const removeFile = (value) => {
        let newFileState = fileState;
        let arrayOfFiles = fileState.fileList;
        let dataToRemove = fileData;
        let fullForm = { ...props.fullFormState };
        const index = arrayOfFiles.indexOf(value);
        if (index > -1) {
            arrayOfFiles.splice(index, 1);
            dataToRemove.splice(index, 1);
        }
        setFileData([...dataToRemove]);
        newFileState.fileList = arrayOfFiles;
        fullForm.pages.replaceFile.imageID = "";
        fullForm.pages.replaceFile.imageFileName = "";
        updateFileState({ ...newFileState });
        displayError("");
        props.onMultiFieldChange(fullForm);
    }

    useEffect(() => {

        const filesFromSession = props.formState.file || null;
        updateFileState({
            ...fileState,
            fileList: filesFromSession !== null ? filesFromSession.fileList : [],
            casesLoading: false,
            pageLoading: false,
            updateCaseTable: false
        });

    }, [fileState.updateFileTable]);

    const fileSelectedHandler = async (event) => {
        if (event.target.files[0] === undefined) {
            setPosting(false);
            event.target.value = "";
            return;
        }
        let fileSize = event.target.files[0].size;
        let fileName = event.target.files[0].name;
        let sameName = false;
        fileState.fileList.forEach((element, index) => {
            if (element.name === fileName) {
                sameName = true;
            }
        })

        if (sameName) {
            displayError("Same file upload is not allowed.");
            event.target.value = "";
            return;
        }
        let acceptedExtension = ["pdf", "mtiff", "tif", "tiff"];
        let extension = fileName.split('.').pop();

        if (Number(fileSize) > 20971520) {
            displayError("File with maximum size of 20MB can be uploaded.");
            event.target.value = "";
            return;
        }
        if (!acceptedExtension.includes(extension.toLowerCase())) {
            displayError("Only files with extensions .pdf, .tif, .tiff, .mtiff are allowed.");
            event.target.value = "";
            return;
        }
        const dateTime = format(new Date(), "MM/dd/yyyy hh:mm a");
        let fileList = {
            name: fileName,
            key: null,
            dateTime: dateTime,
            extension: event.target.files[0].type,
        }
        let newFileState = fileState;
        let arrayOfFiles = fileState.fileList;
        arrayOfFiles.push(fileList);
        newFileState.fileList = arrayOfFiles;
        updateFileState({ ...newFileState });
        handleValueChange('imageFileName', fileName);
        displayError("");
        const file = event.target.files[0];

        new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                resolve(event.target.result);
            };

            reader.onerror = (err) => {
                reject(err);
            };

            reader.readAsDataURL(file);
        }).then((data) => {
            let arrayOfData = fileData;

            if (fileState.fileList.length > arrayOfData.length) {
                const nullArray = fileState.fileList.length - arrayOfData.length
                for (var i = 1; i < nullArray; i++) {
                    arrayOfData.push(null);
                }
            }
            arrayOfData.push(data);
            setFileData([...arrayOfData]);

        });
        event.target.value = "";
    }

    const handleModalOpen = () => {
        inputFile.current.click();
    }

    const handleOnSubmit = async () => {
        if (fileState.fileList.length === 0) {
            setPosting(false);
            displayError("Please select at least one file.");
            return
        }
        if (props.formState.imageID !== "") {
            props.onNext();
            return;
        }
        setPosting(true);
        displayError("");
        let body;
        fileState.fileList.forEach((element, i) => {
            let dataToPush = {
                FileName: element.name,
                Data: fileData[i],
                IsEncrypt: true
            }
            body = dataToPush;
        });

        let newFileState = fileState;
        let apiError = [];

        await httpRequest.post(`${covrServicesUrl}/API/MorganStanley/CreateImage`, body)
            .then((data) => {
                if (data.content && data.content.newID) {
                    let fullForm = { ...props.fullFormState };
                    fullForm.pages.replaceFile.imageID = data.content.newID;
                    props.onMultiFieldChange(fullForm);
                }

                if (!data.success) {
                    apiError.push(data.message + '<br/>')
                }
            }).catch((error) => {
                setPosting(false);
            })

        if (apiError.length !== 0) {
            displayError(apiError.toString());
            setPosting(false);
        }
        if (error === '' && apiError.length === 0) {
            updateFileState(newFileState)
            props.onNext();
        }
    }

    const disableFileUpload = (fileState && fileState.fileList.length !== 0 || fileData.length !== 0)

    const classes = useStyles();
    return (
        <Container fluid className='border-class'>
            <Form onSubmit={handleSubmit(handleOnSubmit)}>
                <Row className="justify-content-center pt-4 file-coverage">
                    <Col lg={8}>
                        <TitleComponent icon={FileDownload} title="Upload Attachments" />
                        <div>
                            <div>
                                <p className='mb-0 mt-1 stat-title-grey'>You must attach an image of the full illustration, which has been signed by the proposed insured and/or owner of the policy.Supported file types: TIFF, TIF, MTIFF, and PDF. Maximum file size is 20 megabytes.</p>
                                <div className='pt-2'>
                                    <label className={disableFileUpload ? classes.disabledButtonSelect : classes.buttonSelect} disabled={disableFileUpload ? true : false} onClick={() => handleModalOpen()}>SELECT FILE</label>
                                    <input
                                        id="file"
                                        name="file"
                                        style={{ display: 'none' }}
                                        type={"file"}
                                        ref={inputFile}
                                        onChange={fileSelectedHandler}
                                        disabled={disableFileUpload ? true : false}
                                        errors={errors.file}
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <React.Fragment>
                    <Row className='justify-content-center mb-3 px-5'>
                        <div className='errorMessageCustom' dangerouslySetInnerHTML={{ __html: error }}></div>
                    </Row>
                    <Row>
                        <Col sm={{ span: 8, offset: 2 }}>
                            <FileTable
                                IllustrationRequest={props.IllustrationRequest ? true : false}
                                state={fileState}
                                stateUpdate={updateFileState}
                                fileData={fileData}
                                postingApp={postingApp}
                                removeFile={(value) => removeFile(value)}
                                setPosting={(bool) => setPosting(bool)}
                                imageId={props.formState.imageID}
                            />
                        </Col>
                    </Row>
                    <BackNextButton onBack={props.onBack} disabled={postingApp} />
                </React.Fragment>

            </Form>
            <NextStepModal show={modalShow} onHide={() => setModalShow(false)} />
        </Container>
    );
}

ReplaceFile.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
};

ReplaceFile.DefaultFormState = (prefill) => {
    return {
        fileState: null,
        uploadAs: prefill ? 'Illustration' : '',
        file: '',
        imageID: '',
        imageFileName: ''
    };
};


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/UploadFile/ReplaceFile.js